<template>
    <span :class="`char-counter text-color tertiary font ${defaultClasses}`">
        <span class="text-count font-medium" :class="{ 'is-invalid': isInvalid }">{{ formattedCount }}</span>
        <span class="font-medium">/</span>
        <span class="text-max font-medium">{{ max }}</span>
    </span>
</template>

<script>
export default {
  props: {
    max: {
      type: [Number, String],
      default: 100,
    },
    count: {
      type: [Number, String],
      default: 0,
    },
    defaultClasses: {
      type: String,
      default: 'f-s-12 l-h-16 f-w-500',
    },
  },
  computed: {
    formattedCount() {
      return (Number(this.count)).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
    },
    isInvalid() {
      return this.count > this.max;
    },
  },
  watch: {
    isInvalid(bool) {
      this.$emit('overload', bool);
    },
  },
};
</script>

<style lang="scss" scoped>
.char-counter {
    // width: 40px;
    display: flex;
    .text-count {
        &.is-invalid {
          color: #E11900;
        }
    }

    .text-max {}
}
</style>
